

























import {Component, Watch, Vue} from 'vue-property-decorator';

import MeetingLive from "@share/meeting-view/MeetingLive.vue";
import SessionWrapper from "./SesionWrapper.vue";
import AppointmentRoot from "@share/appointment/AppointmentRoot.vue"
import { MiniPlayerParams } from '@service/store/types/MiniPlayerState';
import { BackgroundViewHelper } from "./BackgroundViewHelper/BackgroundViewHelper"
import { BackgroundViewName } from "./types/BackgroundViewName"
import { RouteNamesEnum } from '@service/router/RouteNamesEnum';
import { isRouteForBackground, isRouteMeetings } from "@service/router/helpers/commonRoutesHelper";

@Component({
    name: 'BackgroundView',
    components: { MeetingLive, SessionWrapper, AppointmentRoot }
})
export default class BackgroundView extends Vue {

    BackgroundViewName = BackgroundViewName;
    meetingId: string | null = null;

    deactivated() {
        this.$store.dispatch("backgroundView/clearBroadcastQue");
    }

    updateBroadcastQue(viewName: BackgroundViewName, isLive: boolean) {
        this.$store.dispatch("backgroundView/updateBroadcastQue", {viewName, isLive, id: this.$route.params.id})
        this.setMiniPlayerVisibility(this.routeName as RouteNamesEnum);
    }

    setOffline(viewName: BackgroundViewName) {
        this.$store.dispatch("backgroundView/setOffline", viewName);
    }

    initNewBroadcast(viewName: string) {
        this.$store.dispatch("backgroundView/initNewBroadcast", viewName);
    }

    @Watch('routeName')
    async watchRouteName(routeName: string | null | undefined) {

        if(!routeName) {return;}

        this.setMiniPlayerVisibility(routeName as RouteNamesEnum);

        if(isRouteMeetings(routeName)) {
            this.meetingId = this.$route.params.id;
        }

        if(this.backgroundRoute) {

            const viewName = BackgroundViewHelper.getViewByRouteName(routeName);

            if(!this.broadcastQue[viewName]) {
                this.initNewBroadcast(viewName);
            }
        }
    }

    @Watch('meetingRouteId')
    watchRouteId() {
        if(this.meetingRouteId) {
            this.meetingId = this.meetingRouteId;
        }
    }

    get meetingRouteId() {
        return this.showMeetingLive && this.$route.params.id || "";
    }

    onMeetingClose() {
        this.$router.push({
            name: "Home"
        });
    }

    updateMiniPlayerParams(params: MiniPlayerParams) {
        this.$store.dispatch('miniPlayer/setMiniPlayerParams', params);
    }

    setMiniPlayerVisibility(routeName: RouteNamesEnum) {
        let showMiniPlayer = Boolean(this.anyLive);

        const viewNameByRoute = BackgroundViewHelper.getViewByRouteName(routeName);

        if(viewNameByRoute === this.activeBroadcastView) {
            showMiniPlayer = false;
        }

        if(this.showPlayer !== showMiniPlayer) {
            this.$store.dispatch("miniPlayer/setShowPlayer", showMiniPlayer);
        }
    }

    get broadcastQue() {
        return this.$store.state.backgroundView.broadcastQue;
    }

    get activeBroadcastView() {
        return this.$store.getters["backgroundView/activeBroadcastView"];
    }

    get anyLive() {
        return BackgroundViewHelper.checkBroadcastIsBusy(this.broadcastQue)
    }

    get routeName() {
        return this.$route.name;
    }

    get backgroundRoute() {
        return isRouteForBackground(this.routeName || '');
    }

    get showMeetingLive() {
        return isRouteMeetings(this.$route.name || '');
    }

    get showAppointment() {
        return this.$route.name === RouteNamesEnum.appointment;
    }

    get showSession() {
        return this.$route.name === "ViewSession";
    }

    get showPlayer() {
        return this.$store.state.miniPlayer.showPlayer
    }
}
